module.exports = __webpack_public_path__ + "static/images/notepad.c9f85bdb10993df2a8ce02565ecf20a9.svg";